import React, { useState } from 'react'
import { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap'
import { Form, InputPicker } from 'rsuite';
import { getCountries, getStates } from '../../../services/Shared/codeTable.service'
import RedStar from './RedStar';
import TextArea from './TextArea';
import { AccessibleInputPicker } from './AccessibleComponents';

function Address(props) {
    const [countryValue, setCountryValue] = useState();
    const [countries, setCountries] = useState([])
    const [states, setStates] = useState([])
    const [loadedDropDowns, setLoadedDropDowns] = useState(false);
    useEffect(() => {
        if (!loadedDropDowns) {
            getCountries().then(setCountries);
            getStates().then(setStates);
            setLoadedDropDowns(true);
        }
        setCountryValue(props.boundValues?.country?.country);
    }, [props])
    return <>
        <Form.Group>
            <Row>
                <Col sm={3}>
                    <Form.ControlLabel>
                        <strong>
                            Country {!props.hideRequired && <RedStar />}
                        </strong>
                    </Form.ControlLabel>
                </Col>
                <Col sm={9}>
                    <Form.Control
                        errorMessage={(!props.boundValues?.country && (props.boundValues?.showErrors || props.showErrors)) ? "This field is required" : null}
                        block
                        name={props.countryName ? props.countryName : "country"}
                        accepter={AccessibleInputPicker}
                        ariaLabel="Country"
                        data={countries}
                        onChange={(value) => { setCountryValue(value) }}
                        readOnly={props.readOnly} />
                </Col>
            </Row>
            <Form.HelpText className="d-none">Country</Form.HelpText>
        </Form.Group>
        <Form.Group>
            <Row>
                <Col sm={3}>
                    <Form.ControlLabel>
                        <strong>Address</strong> {!props.hideRequired && <RedStar />}
                    </Form.ControlLabel>
                </Col>
                <Col sm={9}>
                    <Form.Control
                        errorMessage={
                            (!props.boundValues?.streetAddress && (props.boundValues?.showErrors || props.showErrors))
                                ? "This field is required" : null}
                        rows={3}
                        accepter={TextArea}
                        name={props?.addressName ? props.addressName : "streetAddress"}
                        readOnly={props.readOnly} />
                </Col>
            </Row>
            <Form.HelpText className="d-none">Address</Form.HelpText>

        </Form.Group>
        <Form.Group>
            <Row>
                <Col sm={3}>
                    <Form.ControlLabel>
                        <strong>City </strong>{!props.hideRequired && <RedStar />}
                    </Form.ControlLabel>
                </Col>
                <Col sm={9}>
                    <Form.Control
                        errorMessage={
                            (!props.boundValues?.city && (props.boundValues?.showErrors || props.showErrors))
                                ? "This field is required" : null}
                        name={props?.cityName ? props.cityName : "city"}
                        readOnly={props.readOnly} />
                </Col>
            </Row>
            <Form.HelpText className="d-none">City</Form.HelpText>
        </Form.Group>
        {
            countryValue === "United States" &&
            <Form.Group>
                <Row>
                    <Col sm={3}>
                        <Form.ControlLabel>
                            <strong>State </strong>{!props.hideRequired && <RedStar />}
                        </Form.ControlLabel>
                    </Col>
                    <Col sm={9}>
                        <Form.Control
                            errorMessage={(!props.boundValues?.state && (props.boundValues?.showErrors || props.showErrors)) ? "This field is required" : null}
                                accepter={AccessibleInputPicker}
                            ariaLabel="State"
                            placeholder="Please Select"
                            block
                            data={states}
                            name={props?.stateName ? props.stateName : "state"}
                            searchBy={(userInput, label, dataItem) => { if (label.toLowerCase().startsWith(userInput.toLowerCase()) || !userInput) return true; }}
                            readOnly={props.readOnly} />
                    </Col>
                </Row>
                <Form.HelpText className="d-none">State</Form.HelpText>
            </Form.Group>
        }
        {
            countryValue !== "United States" &&
            <Form.Group>
                <Row>
                    <Col sm={3}>
                        <Form.ControlLabel>
                            <strong>State/Province/Region </strong>
                        </Form.ControlLabel>
                    </Col>
                    <Col sm={9}>
                        <Form.Control
                            name={props?.stateProvinceRegionName ? props.stateProvinceRegionName : "provinceRegion"}
                            readOnly={props.readOnly} />
                    </Col>
                </Row>
                <Form.HelpText className="d-none">State/Province/Region</Form.HelpText>
            </Form.Group>
        }
        <Form.Group>
            <Row>
                <Col sm={3}>
                    <Form.ControlLabel>
                        <strong>Zip/Postal Code </strong>{!props.hideRequired && <RedStar />}
                    </Form.ControlLabel>
                </Col>
                <Col sm={9}>
                    <Form.Control
                        errorMessage={(!props.boundValues?.postalCode && (props.boundValues?.showErrors || props.showErrors)) ? "This field is required" : null}
                        name={props?.postalCodeName ? props.postalCodeName : "postalCode"}
                        readOnly={props.readOnly} />
                </Col>
            </Row>
            <Form.HelpText className="d-none">Postal Code</Form.HelpText>
        </Form.Group>
    </>;
}
export default Address;